// import DashboardIcon from "@material-ui/icons/Dashboard";
import EventIcon from "@material-ui/icons/Event";
import List from "@material-ui/icons/List";
import {
  // AnnouncementIcon,
  // StaffIcon,
  SpeakerIcon,
  // ContentIcon
} from "../utils/constants";
// import LineWeightIcon from "@material-ui/icons/LineWeight";
import PeopleIcon from "@material-ui/icons/People";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import CategoryIcon from "@material-ui/icons/Category";
import ReceiptIcon from "@material-ui/icons/Receipt";
// import EmailIcon from "@material-ui/icons/Email";
import DescriptionIcon from "@material-ui/icons/Description";

// import Dashboard from "../views/ISEAS/Dashboard";
import ManageEvents from "../views/ISEAS/EventManagement";
// import NewsAndAnnouncements from "../views/ISEAS/NewsAndAnnouncements";
import ManageUsers from "../views/ISEAS/UserManagement";
import AddManageUsers from "../views/ISEAS/UserManagement/AddManageUsers";

import AddWebinar from "../views/ISEAS/WebinarManagement/AddEvent";
import WebinarDetail from "../views/ISEAS/WebinarManagement/EventDetail";
import ManageWebinar from "../views/ISEAS/WebinarManagement";

import AddVIP from "../views/ISEAS/vipbooking/addvip";
// import VIPDetail from "../views/ISEAS/vipbooking/detailvipbooking";
import ManageVIP from "../views/ISEAS/vipbooking";

import ManageStaff from "../views/ISEAS/StaffManagement";
import ManageSpeaker from "../views/ISEAS/SpeakerManagement";
import ManageCategory from "../views/ISEAS/CategoryManagement";
import ManageFAQ from "../views/ISEAS/ContentBuilder/ManageFAQ";
import ManageTermsAndConditions from "../views/ISEAS/ContentBuilder/ManageTermsAndConditions";
import ManagePrivacyPolicy from "../views/ISEAS/ContentBuilder/ManagePrivacyPolicy";
// import BulkEmailing from "../views/ISEAS/BulkEmailing";
import Reports from "../views/ISEAS/Reports";
import { AddCategory } from "../views/ISEAS/CategoryManagement/AddCategory";
import AddStaff from "../views/ISEAS/StaffManagement/AddStaff";
import AddSpeaker from "../views/ISEAS/SpeakerManagement/AddSpeaker";
import AddEvent from "../views/ISEAS/EventManagement/AddEvent";
import AddFAQ from "../views/ISEAS/ContentBuilder/AddFAQ";
import EventDetail from "../views/ISEAS/EventManagement/EventDetail";
import AddNewsAndAnnouncements from "../views/ISEAS/NewsAndAnnouncements/AddNewsAndAnnouncement";

import Coupons from "../views/ISEAS/coupon/index";
import CouponsAdd from "../views/ISEAS/coupon/add";
import ViewDetails from "../views/ISEAS/WebinarManagement/ViewDetails";
import ViewEventDetails from "../views/ISEAS/EventManagement/ViewEventDetails";
import ManageAdmin from "../views/ISEAS/AdminManagement";
import AddAdmin from "../views/ISEAS/AdminManagement/AddAdmin";
import VipBookingsDetails from "../views/ISEAS/vipbooking/vipBookingsDetails"
import RegisterVipToWebinar from "../views/ISEAS/vipbooking/RegisterVipToWebinar";

var dashRoutes = [
  // {
  //   path: "/admin/dashboard",
  //   name: "Dashboard",
  //   hide: false,
  //   icon: DashboardIcon,
  //   component: Dashboard
  // },

  {
    path: "/admin/managewebinar/webinarlist",
    name: "Webinar Management",
    hide: false,
    icon: EventIcon,
    component: ManageWebinar,
  },
  {
    path: "/admin/managewebinar/addwebinar",
    name: "Webinar Management",
    hide: true,
    icon: SpeakerIcon,
    component: AddWebinar,
  },
  {
    path: "/admin/managewebinar/editwebinar",
    name: "Webinar Management",
    hide: true,
    icon: SpeakerIcon,
    component: AddWebinar,
  },
  {
    path: "/admin/managewebinar/webinardetail",
    name: "Webinar Management",
    hide: true,
    icon: SpeakerIcon,
    component: WebinarDetail,
  },
  {
    path: "/admin/vip/viplist/vipbookingdetails",
    name: "VIP Booking Management",
    hide: true,
    icon: SpeakerIcon,
    component: VipBookingsDetails,
  },
  {
    path: "/admin/vip/viplist/addtowebinar/:id",
    name: "VIP Booking Management",
    hide: true,
    icon: SpeakerIcon,
    component: RegisterVipToWebinar,
  },
  {
    path: "/admin/managewebinar/registrationDetails",
    name: "Registration Details",
    hide: true,
    icon: SpeakerIcon,
    component: ViewDetails,
  },

  {
    path: "/admin/manageevent/eventregistrationDetails",
    name: "Event Registration Details",
    hide: true,
    icon: SpeakerIcon,
    component: ViewEventDetails,
  },
  {
    path: "/admin/vip/viplist",
    name: "VIP Booking Management",
    hide: false,
    icon: EventIcon,
    component: ManageVIP,
  },
  {
    path: "/admin/vip/:id",
    name: "VIP Booking Management",
    hide: true,
    icon: SpeakerIcon,
    component: AddVIP,
  },
  {
    path: "/admin/vip/editvip",
    name: "VIP Booking Management",
    hide: true,
    icon: SpeakerIcon,
    component: AddVIP,
  },
  {
    path: "/admin/manageevents/eventlist",
    name: "Event Management",
    hide: false,
    icon: EventIcon,
    component: ManageEvents,
  },
  {
    path: "/admin/managecoupon/couponlist",
    name: "Coupon Management",
    hide: false,
    icon: EventIcon,
    component: Coupons,
  },
  {
    path: "/admin/managecoupon/addcoupon",
    name: "Coupon Management",
    hide: true,
    icon: EventIcon,
    component: CouponsAdd,
  },

  {
    path: "/admin/managecoupon/editcoupon",
    name: "Coupon Management",
    hide: true,
    icon: EventIcon,
    component: CouponsAdd,
  },
  // {
  //   path: "/admin/newsandannouncements/newsandannouncementlist",
  //   name: "News & Announcements",
  //   hide: false,
  //   icon: LineWeightIcon,
  //   component: NewsAndAnnouncements
  // },
  {
    path: "/admin/manageusers",
    name: "User Management",
    hide: false,
    icon: PeopleIcon,
    component: ManageUsers,
  },
  {
    path: "/admin/addusers",
    name: "User Management",
    hide: true,
    icon: PeopleIcon,
    component: AddManageUsers,
  },
  {
    path: "/admin/managestaff/stafflist",
    name: "Staff Management",
    hide: false,
    icon: GroupAddIcon,
    component: ManageStaff,
  },
  {
    path: "/admin/managespeaker/speakerlist",
    name: "Speaker Management",
    hide: false,
    icon: RecordVoiceOverIcon,
    component: ManageSpeaker,
  },
  {
    path: "/admin/managecategory/categorylist",
    name: "Category Management",
    hide: false,
    icon: CategoryIcon,
    component: ManageCategory,
  },
  // {
  //   path: "/admin/managecategory/categorylist",
  //   name: "Category Management",
  //   hide: false,
  //   icon: CategoryIcon,
  //   component: ManageCategory,
  // },
  // {
  //   path: "/admin/manage-admin/list",
  //   name: "Admin Management",
  //   hide: false,
  //   icon: PeopleIcon,
  //   component: ManageAdmin,
  // },
  {
    path: null,
    collapse: true,
    name: "Static Content",
    hide: false,
    state: "user",
    icon: ReceiptIcon,
    component: null,
    views: [
      {
        path: "/admin/faq",
        name: "Manage FAQ",
        hide: false,
        icon: List,
        component: ManageFAQ,
      },
      {
        path: "/admin/termsandconditions",
        name: "Terms & Conditions",
        hide: false,
        icon: List,
        component: ManageTermsAndConditions,
      },
      {
        path: "/admin/privacypolicy",
        name: "Privacy Policy",
        hide: false,
        icon: List,
        component: ManagePrivacyPolicy,
      },
    ],
  },
  // {
  //   path: "/admin/bulkemailing",
  //   name: "Bulk Emailing",
  //   hide: false,
  //   icon: EmailIcon,
  //   component: BulkEmailing
  // },
  {
    path: "/admin/reports",
    name: "Reports",
    hide: false,
    icon: DescriptionIcon,
    component: Reports,
  },
  {
    path: "/admin/manageevents/eventdetail",
    name: "Event Details",
    hide: true,
    icon: SpeakerIcon,
    component: EventDetail,
  },
  {
    path: "/admin/manageevents/addevent",
    name: "Add Event",
    hide: true,
    icon: SpeakerIcon,
    component: AddEvent,
  },
  {
    path: "/admin/manageevents/editevent",
    name: "Edit Event",
    hide: true,
    icon: SpeakerIcon,
    component: AddEvent,
  },
  {
    path: "/admin/newsandannouncements/addnewsandannouncement",
    name: "Add News & Announcement",
    hide: true,
    icon: SpeakerIcon,
    component: AddNewsAndAnnouncements,
  },
  {
    path: "/admin/newsandannouncements/editnewsandannouncement",
    name: "Edit News & Announcement",
    hide: true,
    icon: SpeakerIcon,
    component: AddNewsAndAnnouncements,
  },
  {
    path: "/admin/managestaff/addstaff",
    name: "Add Staff",
    hide: true,
    icon: SpeakerIcon,
    component: AddStaff,
  },
  {
    path: "/admin/managestaff/viewstaff",
    name: "View Staff",
    hide: true,
    icon: SpeakerIcon,
    component: AddStaff,
  },
  {
    path: "/admin/managestaff/editstaff",
    name: "Edit Staff",
    hide: true,
    icon: SpeakerIcon,
    component: AddStaff,
  },
  {
    path: "/admin/managespeaker/addspeaker",
    name: "Add Speaker",
    hide: true,
    icon: SpeakerIcon,
    component: AddSpeaker,
  },
  {
    path: "/admin/managespeaker/viewspeaker",
    name: "View Speaker",
    hide: true,
    icon: SpeakerIcon,
    component: AddSpeaker,
  },
  {
    path: "/admin/managespeaker/editspeaker",
    name: "Edit Speaker",
    hide: true,
    icon: SpeakerIcon,
    component: AddSpeaker,
  },
  {
    path: "/admin/managecategory/addcategory",
    name: "Add Category",
    hide: true,
    icon: SpeakerIcon,
    component: AddCategory,
  },
  {
    path: "/admin/managecategory/editcategory",
    name: "Edit Category",
    hide: true,
    icon: SpeakerIcon,
    component: AddCategory,
  },
  {
    path: "/admin/add-faq",
    name: "Add FAQ",
    hide: true,
    icon: SpeakerIcon,
    component: AddFAQ,
  },
  {
    path: "/admin/view-faq",
    name: "View FAQ",
    hide: true,
    icon: SpeakerIcon,
    component: AddFAQ,
  },
  {
    path: "/admin/edit-faq",
    name: "Edit FAQ",
    hide: true,
    icon: SpeakerIcon,
    component: AddFAQ,
  },
  {
    path: "/admin/manage-admin/add",
    name: "Add Admin",
    hide: true,
    icon: SpeakerIcon,
    component: AddAdmin,
  },
  {
    redirect: true,
    path: "/admin",
    pathTo: "/admin/pages/login-page",
    name: "Login",
  },
  { redirect: true, path: "/", pathTo: "/admin/pages", name: "Login" },
];
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx